import { useEffect, useState } from "react";
import Button from "../../Button/Button";
import "./VendorCard.css";
import editIcon from "../../../Assets/Images/edit-icon.svg";
import contactPersonIcon from "../../../Assets/Images/contact-person-icon.png";
import designationIcon from "../../../Assets/Images/designation-icon.png";
import mailIcon from "../../../Assets/Images/mail_icon.png";
import clientIcon from "../../../Assets/Images/client-menu-icon-active.svg";
import {
  applyEllipsis,
} from "../../Common-Function/CommonFunctions";
const VendorCard = ({
  client,
  viewVendor,
  editVendor,
  hideEditIcon = false,
}) => {
  const [ellipsisLength, setEllipsisLength] = useState(() => {
    if (window.innerWidth > 2000) return 50;
    if (window.innerWidth <= 2000 && window.innerWidth >= 1306) return 30;
    if (window.innerWidth <= 1306 && window.innerWidth >= 1190) return 25;
    if (window.innerWidth <= 1190 && window.innerWidth >= 980) return 40;
    if (window.innerWidth <= 980 && window.innerWidth >= 764) return 25;
    if (window.innerWidth <= 764 && window.innerWidth >= 425) return 50;
    if (window.innerWidth < 425) return 20;
    if (window.innerWidth < 810) return 20;
    return 30;
  });

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1700) {
        setEllipsisLength(50);
      } else if (window.innerWidth <= 2000 && window.innerWidth >= 1306) {
        setEllipsisLength(30);
      } else if (window.innerWidth <= 1306 && window.innerWidth >= 1190) {
        setEllipsisLength(25);
      } else if (window.innerWidth <= 1190 && window.innerWidth >= 980) {
        setEllipsisLength(40);
      } else if (window.innerWidth <= 980 && window.innerWidth >= 764) {
        setEllipsisLength(25);
      } else if (window.innerWidth <= 764 && window.innerWidth >= 425) {
        setEllipsisLength(50);
      } else if (window.innerWidth < 425) {
        setEllipsisLength(20);
      } else if (window.innerWidth < 810) {
        setEllipsisLength(20);
      } else {
        setEllipsisLength(30);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={"client-card"}>
      <div className="client-card-header">
        <div className="client-details-header">
          <img
            src={clientIcon}
            alt="clientIcon"
            className="client-header-card-icon"
          />
          <h3 className="client-name" style={{ color: "var(--header__color)" }}>
            {applyEllipsis((client.name), ellipsisLength)}
          </h3>
          {/* <div
            className="client-industry"
            style={{ color: "var(--job-Description_Color)" }}
          >
            {client.contact_designation || "N/A"}
          </div> */}
        </div>
        {!hideEditIcon && (
          <div
            className="edit-icon-container"
            onClick={(e) => {
              e.stopPropagation();
              editVendor(client.id);
            }}
          >
            <img src={editIcon} alt="Edit" className="edit-icon" />
          </div>
        )}
      </div>

      <div className="client-card-body">
        <div className="client-contact">
          {/* <h5 className="client-contact-header">Contact</h5> */}
          <img
            src={contactPersonIcon}
            alt="contactPersonIcon"
            className="client-inner-card-icon"
          />
          <span className="client-contact-text">
            {applyEllipsis(client.contact_person, ellipsisLength)}
          </span>
        </div>
        <div className="client-contact">
          {/* <h5 className="client-contact-header">Contact</h5> */}
          <img
            src={designationIcon}
            alt="designationIcon"
            className="client-inner-card-icon"
          />
          <span className="client-contact-text">
            {applyEllipsis(client.contact_designation || "N/A", ellipsisLength)}
          </span>
        </div>
        <div className="client-contact">
          {/* <h5 className="client-contact-header">Email</h5> */}
          <img
            src={mailIcon}
            alt="mailIcon"
            className="client-inner-card-icon"
          />
          <span className="client-contact-text">
            {applyEllipsis(client.email, ellipsisLength)}
          </span>
        </div>
        <div className="client-button-container">
          <Button
            label="View"
            backgroundColor="none"
            color="#6860EE"
            border="1px solid #6860EE"
            style={{ padding: "4px 12px" }}
            event={viewVendor}
          />
        </div>
      </div>

      <div className="client-card-footer"></div>
    </div>
  );
};

export default VendorCard;
